<template>
  <div class="cookie">

    <div class="gdpr-float gdpr-show" :class="{'gdpr-show': false, 'gdpr-hidden': true}" v-on:click="toggle">

    </div>
    <div class="gdpr-cookie-consent" :class="{'gdpr-show': !btnVisible, 'gdpr-hidden': btnVisible}">
      <div class="gdpr-cookie-consent--info" :class="{'gdpr-cookie-consent--info--with-settings': accepted}">
        <div class="gdpr-cookie-consent__message">
          <p>
            Radi prispôsobíme obsah a vizualizáciu webovej stránky a reklám, ako aj poskytovanie funkcií sociálnych médií, aby sme vám poskytli lepší zážitok z používania webovej stránky. Umožní nám to analýza návštevnosti a aktivít na webovej stránke, k čomu potrebujeme používať vaše online identifikátory (cookies, IP adresy).
          </p>
          <div class="gdpr-cookie-consent--settings">
            <div class="">
              <div class="gdpr-cookie-consent__inputs">
                <div v-for="(setting, key) in cookieTypes" class="gdpr__checkbox gdpr__checkbox-primary" :key="key">
                  <input v-model="setting.value" :id="key" class="styled" type="checkbox" :name="key" :disabled="setting.disabled">
                  <label :for="key">
                    {{setting}}
                    <small>{{setting.desc}}</small>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <router-link class="be-you-btn be-you-btn-decline be-you-btn-max-width" :to="{name: 'Gdpr'}" target="_blank">Zásady používania</router-link>
          <button v-on:click='submit' class="be-you-btn be-you-btn-accept be-you-btn-max-width">Súhlasím</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import cookieTypes from './cookieTypes'

export default {
  data () {
    return {
      cookieTypes: cookieTypes,
      container_cookie: '.gdpr-cookie-consent',
      container_cookie_settings: '.gdpr-cookie-consent--info--with-settings',
      btnVisible: false,
      ajax_link: '/gdpr/cookieset',
      hash_show: 'cookie-preferences'
    }
  },
  computed: {
    cookies: function () {
      let _cookies = {}
      for (let cookie in this.cookieTypes) {
        _cookies[cookie] = this.cookieTypes[cookie].value
      }
      return _cookies
    },
    accepted: function () {
      return this.$cookie.get('accepted')
    }
  },
  components: {
  },
  created: function () {
    if (this.$cookie.get('accepted')) {
      this.btnVisible = true
      let gdpr = JSON.parse(this.$cookie.get('gdpr'))
      for (let g in gdpr) {
        this.cookieTypes[g].value = gdpr[g]
      }
    }
  },
  methods: {
    toggle: function () {
      this.btnVisible = !this.btnVisible
    },

    submit: function () {
      this.$cookie.set('accepted', true)
      this.btnVisible = true
      this.$cookie.set('gdpr', JSON.stringify(this.cookies))

      // axios
      axios.post('http://be-you.local/backend/index.php', this.cookies, {'responseType': 'json'}).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../assets/css/variables.scss";

  .be-you-btn {
    &-decline {
      float: left;
    }
    &-accept {
      float: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Cookie.vue